import { defineMessages } from 'react-intl';

export default defineMessages({
  headTitle: {
    id: 'default.head.title',
    defaultMessage: 'Log in with Atlassian account',
  },
});
